const NG_LIST = [
  "セックス",
  "アナル",
  "オナニー",
  "ケツアナ",
  "けつ穴",
  "ちんこ",
  "ちんぽ",
  "マンコ",
  "マンチョ",
  "青姦",
  "淫売",
  "クンニ",
  "強姦",
  "SEX",
  "中出し",
  "３P",
  "騎乗位",
  "フェラチオ",
  "痴女",
  "近親相姦",
  "盗撮",
  "パイズリ",
  "潮吹き",
  "淫乱",
  "手コキ",
  "顔射",
  "射精",
  "ハメ撮り",
  "指マン",
  "手マン",
  "乱交",
  "パイパン",
  "イラマチオ",
  "シックスナイン",
  "死",
  "殺",
  "コロス",
  "サツジン",
  "サツガイ",
  "サツリク",
  "ころす",
  "さつじん",
  "さつがい",
  "さつりく",
  "覚醒剤",
  "シャブ",
  "デキシー",
  "シンナー",
  "純トロ",
  "大麻",
  "マリファナ",
  "ガンジ",
  "ハシッシュ",
  "ハッシシ",
  "ヘロイン",
  "チャイナホワイト",
  "スマック",
  "メキシカンブラウン",
  "ジャック",
  "コカイン",
  "ノースキャンディ",
  "マザーオブパール",
  "ボリビアンロック",
  "ホワイトレディ",
  "フレイク",
  "トゥート",
  "LSD", "ＬＳＤ",
  "MDMA", "ＭＤＭＡ",
  "MDA", "ＭＤＡ",
  "ラブドラッグ",
  "せっくす",
  "あなる",
  "おなにー",
  "けつあな",
  "ケツ穴",
  "チンコ",
  "チンポ",
  "まんこ",
  "おまんまん",
  "あおかん",
  "いんばい",
  "くんに",
  "ごうかん",
  "sex",
  "なかだし",
  "さんぴー",
  "３ピー",
  "きじょうい",
  "ふぇらちお",
  "ぱいずり",
  "テコキ",
  "いんらん",
  "てこき",
  "がんしゃ",
  "らんこう",
  "ぱいぱん",
  "いらまちお",
  "しっくすないん",
  "かくせいざい",
  "たいま",
];

var NG_REG = new RegExp(NG_LIST.join('|'))

export function ngReg() {
  return NG_REG;
}